'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
const $ = require("jquery");
const init_1 = require("./class/init");
const footer_slide_1 = require("./class/common/footer-slide");
const sp_menu_1 = require("./class/common/sp-menu");
const search_menu_1 = require("./class/common/search-menu");
const navigation_1 = require("./class/common/navigation");
const fadein_content_1 = require("./class/common/fadein-content");
const scroll_1 = require("./class/common/scroll");
const fixed_button_1 = require("./class/common/fixed-button");
const top_slide_1 = require("./class/top/top-slide");
const accordion_1 = require("./class/opencampus/accordion");
$(() => {
    new init_1.default();
    new footer_slide_1.default();
    new top_slide_1.default();
    new search_menu_1.default();
    new navigation_1.default();
    new fadein_content_1.default();
    new fixed_button_1.default();
    new accordion_1.default();
});
new sp_menu_1.default();
new scroll_1.default();
